import React, { useState } from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { axios } from 'lib/axios';
import PageShell, { useBrandToken } from 'components/PageShell';

const NotificationPage = () => {
  const colors = useBrandToken();
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);

  const onFinish = async (values) => {
    setSending(true);
    try {
      await axios.post('/notifications', {
        title: values.title,
        body: values.body,
      });
      message.success('Notification sent');
      form.resetFields();
    } catch (e) {
      // interceptor
    } finally {
      setSending(false);
    }
  };

  return (
    <PageShell
      title="Push notification"
      description="Broadcast a notification to registered app devices."
    >
      <Card
        style={{
          maxWidth: 560,
          borderRadius: 12,
          border: `1px solid ${colors.border}`,
        }}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Enter a title' }]}
          >
            <Input placeholder="e.g. Weekend festival offers" size="large" />
          </Form.Item>
          <Form.Item
            label="Message"
            name="body"
            rules={[{ required: true, message: 'Enter a message' }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Write the notification body..."
            />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            icon={<SendOutlined />}
            loading={sending}
            size="large"
          >
            Send broadcast
          </Button>
        </Form>
      </Card>
    </PageShell>
  );
};

export default NotificationPage;
